// extracted by mini-css-extract-plugin
export default {"headerLogoTitle":"Header_headerLogoTitle__s-OTr","logo":"Header_logo__G+ea6","footer":"Header_footer__JCxJw"};